import { useContext } from 'react';
import { LanguageContext } from '@helsenorge/designsystem-react/utils/language';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { erHelsenorge } from '@helsenorge/framework-utils/hn-proxy-service';
/**
 * Konverterer språkkode fra CMS til LanguageLocale som primært brukes på tjenester
 * @param cultureName Språkkode som brukes i CMS
 * @returns LanguageLocale som brukes på tvers av tjenester og CMS
 */
export const mapCultureNameToLanguageLocale = (cultureName) => {
    switch (cultureName) {
        case 'no': {
            return LanguageLocales.NORWEGIAN;
        }
        case 'nn': {
            return LanguageLocales.NORWEGIAN_NYNORSK;
        }
        case 'en': {
            return LanguageLocales.ENGLISH;
        }
        case 'lt': {
            return LanguageLocales.LITHUANIAN;
        }
        case 'pl': {
            return LanguageLocales.POLISH;
        }
        case 'ru': {
            return LanguageLocales.RUSSIAN;
        }
        case 'ro': {
            return LanguageLocales.ROMANIAN;
        }
        case 'se': {
            return LanguageLocales.SAMI_NORTHERN;
        }
    }
};
/**
 * Konverter språkkode fra document til LanguageLocale som primært brukes på tjenester
 *
 * @returns LanguageLocale som brukes på tvers av tjenester og CMS
 */
export const getDocumentLanguage = () => {
    return mapCultureNameToLanguageLocale(document?.documentElement?.lang);
};
/**
 * Hent nåværende språk fra context. Hvis context ikke finnes og komponenten brukes på www.helsenorge.no,
 * hentes språket fra HTML-dokumentet.
 *
 * @param fallbackLanguage Språket som skal brukes dersom context ikke finnes og komponenten ikke brukes på www.helsenorge.no
 * @returns LanguageContext
 */
export const useLanguage = (fallbackLanguage) => {
    const context = useContext(LanguageContext);
    if (!context && erHelsenorge()) {
        return { language: getDocumentLanguage() || fallbackLanguage };
    }
    else if (!context && !erHelsenorge()) {
        return { language: fallbackLanguage };
    }
    return context;
};
